// extracted by mini-css-extract-plugin
module.exports = {"button":"RemoveBackgroundScreen_button__1rXqH","container":"RemoveBackgroundScreen_container__1TjeM","heading":"RemoveBackgroundScreen_heading__3cYok"};